// src/redux/slices/jobsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { jobsService } from '../../services/jobsService.js'
import { handleApiError } from '../../utils/handleApiError.js'

export const fetchJobs = createAsyncThunk(
    'jobs/fetchJobs',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await jobsService.getJobs(params)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const fetchJobBySlug = createAsyncThunk(
    'jobs/fetchJobBySlug',
    async (slug, { rejectWithValue }) => {
        try {
            const response = await jobsService.getJobBySlug(slug)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

const jobsSlice = createSlice({
    name: 'jobs',
    initialState: {
        jobs: [],
        featuredJobs: [],
        currentJob: null,
        loading: false,
        hasMore: true,
        error: null
    },
    reducers: {
        clearCurrentJob: (state) => {
            state.currentJob = null
        },
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Jobs
            .addCase(fetchJobs.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.loading = false

                // All fetched jobs
                const newJobs = action.payload.data?.jobs || action.payload

                // 🔥 Filter featured jobs from the list
                const featuredJobs = newJobs.filter(job => job.featured)

                if (action.payload.page > 1) {
                    // Append if pagination
                    state.jobs = [...state.jobs, ...newJobs]
                    state.featuredJobs = [...state.featuredJobs, ...featuredJobs]
                } else {
                    // Set fresh if first page
                    state.jobs = newJobs
                    state.featuredJobs = featuredJobs
                }

                // Pagination handling
                state.hasMore = newJobs.length === (action.payload.pagination?.limit || 10)
                state.error = null
            })

            .addCase(fetchJobs.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Fetch Job by Slug
            .addCase(fetchJobBySlug.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchJobBySlug.fulfilled, (state, action) => {
                state.loading = false
                state.currentJob = action.payload?.data?.job
                state.error = null
            })
            .addCase(fetchJobBySlug.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const { clearCurrentJob, clearError } = jobsSlice.actions
export default jobsSlice.reducer